import {
    DROPDOWN_VALUE,
    SAVE_ACCOUNT,
    ACCOUNT_DETAILS,
    ACCOUNT_DETAILS_BY_ID,
    UPDATE_ACCOUNT,
    FETCH_REPORTEE,
    ACCOUNT_FILTER,
    GEO_CITY,
    GET_ACCOUNT_ACTIVITY,
    GET_ACCOUNT_ACTIVITY_BY_ID,
    SAVE_ACTIVITY,
    GET_ACCOUNT_ACTIVITY_LIST,
    GET_V2_OPPORTUNITY_ACTIVITY_TYPE,
    GET_LAST_LEAD_OPPORTUNITY_ACTIVITY, IS_USER_CHECK_IN, INFRA_PROJECT, SAVE_BUSINESS,
    GET_INSPECTION_LIST
} from "./type";
import {STATE_REGION} from "../locations/type";

const initialState = {
    dropdownValue: [],
    saveDetails: [],
    accountDetails: [],
    accountDetailsById: [],
    updateAccountDetails: [],
    reportee:[],
    accountFilterContent:[],
    geoCity:[],
    accountActivity:[],
    accountActivityById:[],
    saveActivity:[],
    accountActivityList:[],
    stateRegionDetails:[],
    leadOpportunityActivity:[],
    LastLeadOpportunityActivity:[],
    userCheckInForModule:[],
    infraProjectResponse: [],
    saveBusiness: [],
    inspectionList: [],
};

const Dropdown = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case DROPDOWN_VALUE:
            return {
                ...state,
                dropdownValue: payload,
            };

        case SAVE_ACCOUNT:
            return {
                ...state,
                saveDetails: payload,
            };
        case ACCOUNT_DETAILS:
            return {
                ...state,
                accountDetails: payload,
            };
        case ACCOUNT_DETAILS_BY_ID:
            return {
                ...state,
                accountDetailsById: payload,
            };
        case UPDATE_ACCOUNT:
            return {
                ...state,
                updateAccountDetails: payload,
            };
        case FETCH_REPORTEE:
            return {
                ...state,
                reportee: payload,
            };
        case ACCOUNT_FILTER:
            return {
                ...state,
                accountFilterContent: payload,
            };
        case GEO_CITY:
            return {
                ...state,
                geoCity: payload,
            };
        case GET_ACCOUNT_ACTIVITY:
            return {
                ...state,
                accountActivity: payload,
            };
        case GET_ACCOUNT_ACTIVITY_BY_ID:
            return {
                ...state,
                accountActivityById: payload,
            };
        case SAVE_ACTIVITY:
            return {
                ...state,
                saveActivity: payload,
            };
        case GET_ACCOUNT_ACTIVITY_LIST:
            return {
                ...state,
                accountActivityList: payload,
            };
        case STATE_REGION:
            return {
                ...state,
                stateRegionDetails: payload,
            };
        case GET_V2_OPPORTUNITY_ACTIVITY_TYPE:
            return {
                ...state,
                leadOpportunityActivity: payload,
            };
        case GET_LAST_LEAD_OPPORTUNITY_ACTIVITY:
            return {
                ...state,
                LastLeadOpportunityActivity: payload,
            };
        case IS_USER_CHECK_IN:
            return {
                ...state,
                userCheckInForModule: payload,
            };
        case INFRA_PROJECT:
            return {
                ...state,
                infraProjectResponse: payload,
            };
        case SAVE_BUSINESS:
            return {
                ...state,
                saveBusiness: payload,
            };
        case GET_INSPECTION_LIST:
            return {
                ...state,
                inspectionList: payload,
            };
        default:
            return {...state};
    }
};

export default Dropdown;